import { render, staticRenderFns } from "./BuyGroupVip.vue?vue&type=template&id=31ca94f8&scoped=true"
import script from "./BuyGroupVip.vue?vue&type=script&lang=js"
export * from "./BuyGroupVip.vue?vue&type=script&lang=js"
import style0 from "./BuyGroupVip.vue?vue&type=style&index=0&id=31ca94f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ca94f8",
  null
  
)

export default component.exports